<template>
  <BaseModal ref="BaseModal" :destroyOnClose="false" @confirm="insert">
    <div class="insert-zimu">
      <SimpleTable
        width="300px"
        :showIndex="false"
        ref="InsertZimuLeft"
        table-code="InsertZimuLeft"
        :columns="columns.left"
        :data="tableData.left"
        :loading="loading.left"
        @row-select="onRowSelectLeft"
      />
      <SimpleTable
        width="250px"
        :showIndex="false"
        ref="InsertZimuCenter"
        table-code="InsertZimuCenter"
        :columns="columns.center"
        :data="tableData.center"
        :loading="loading.center"
        @row-select="onRowSelectCenter"
      />
      <SimpleTable
        style="flex: 1"
        :showIndex="false"
        ref="InsertZimuRight"
        table-code="InsertZimuRight"
        :columns="columns.right"
        :data="tableData.right"
        :loading="loading.right"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'InsertZimu',
  components: { BaseModal, SimpleTable },
  data() {
    return {
      // 页面数据
      loading: {
        left: false,
        center: false,
        right: false
      },
      tableData: {
        left: [],
        center: [],
        right: []
      },
      columns: {
        left: [
          { field: 'name', title: '定额库名称' },
          { field: 'regionName', title: '所属地区' }
        ],
        center: [{ field: 'name', title: '定额分类', tree: true }],
        right: [
          { field: 'code', title: '子目编码' },
          { field: 'name', title: '子目名称' },
          { field: 'unit', title: '单位' }
        ]
      },

      selectLeft: {}
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法,

    async show(options = {}) {
      this.options = { ...options }

      this.tableData.left = []
      this.tableData.center = []
      this.tableData.right = []

      this.$refs.BaseModal.show({
        title: '插入子目',
        width: '1200px',
        confirmText: '选择确定'
      })
      this.getTableDataLeft()
    },

    async getTableDataLeft() {
      this.tableData.left = []
      this.tableData.center = []
      this.tableData.right = []
      this.loading.left = true
      const res = await this.$service.get('/quota-library/list', {})
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.InsertZimuLeft.initialized()
    },
    async getTableDataCenter(obj) {
      this.tableData.center = []
      this.tableData.right = []
      this.loading.center = true
      const res = await this.$service.get(
        '/quota-library/quota-classify/tree',
        {
          quotaLibraryId: obj.id
        }
      )
      this.tableData.center = sortRecords(res.data || [])
      this.loading.center = false
      this.$refs.InsertZimuCenter.initialized()
    },
    async getTableDataRight(obj) {
      this.tableData.right = []
      this.loading.right = true
      const res = await this.$service.get('/quota-library/quota-item/list', {
        quotaLibraryId: this.selectLeft?.id,
        quotaClassifyId: obj.id
      })
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.selectLeft = obj
      this.getTableDataCenter(obj)
    },

    onRowSelectCenter(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataRight(obj)
    },

    insert() {
      const res = this.$refs.InsertZimuRight.getSelectData().map(
        e => e[0].originData
      )
      if (!res.length) {
        this.$message('请选中一条数据！')
        return
      }
      this.$emit(
        'insert',
        res.map(e => ({
          ...e,
          quotaLibraryName: this.selectLeft.name,
          quotaItemId: e.id,
          id: null
        }))
      )
      this.$refs.BaseModal.close()
    }
  }
}
</script>

<style scoped lang="less">
.insert-zimu {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 600px;
  gap: 10px;
}
</style>
